import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import { Routes, Route } from 'react-router-dom'
import NoAuthHomePage from './Models/NoModel/NoAuthHomePage'

class NoAuthLandingPage extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            currentAuth: null,
            modelMenuOpen: false,
            model: 'default',

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleToggle() {
        this.setState(state => ({ modelMenuOpen: !state.modelMenuOpen }));
    }

    handleClose(event) {
        if (this.anchorEl.contains(event.target)) {
            return;
        }

        let model = this.state.model
        if (event.target.attributes.model){
            model = event.target.attributes.model.value
        }

        this.setState({
            modelMenuOpen: false,
            model: model
        });
    }

    fillTopNav() {

    }

    render() {

        return (
            <div style={{height: '100vh'}}>
                <Routes>
                    <Route path='*' element={<NoAuthHomePage/>}>
                    </Route>
                </Routes>
            </div>
        );
    }

}
NoAuthLandingPage.propTypes = {
  classes: PropTypes.object.isRequired
};
const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    root: {
        display: "flex",
        flexWrap: "wrap"
    },
    margin: {
        margin: theme.spacing.unit
    } ,
    withoutLabel: {
        marginTop: theme.spacing.unit * 3
    },
    textField: {
        flexBasis: 200
    },
    buttonTheme: {
        margin: 3,
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
    }
});

export default withStyles(styles)(NoAuthLandingPage);
